import styled from 'styled-components';

export const ButtonImage = styled.div<{
  bottom: boolean;
  highlighted: boolean;
}>`
  background-color: ${(props) =>
    props.highlighted ? props.theme.palette.primary.light : 'transparent'};
  z-index: 11;
  padding: 10px;
  height: 30px;
  border-radius: 7px;
  cursor: pointer;
  font-size: 2em;

  ${(props) => props.bottom && 'margin-top: auto;'};
`;

export const ButtonImageContainer = styled.button<{ bottom: boolean }>`
  position: relative;
  ${(props) => props.bottom && 'margin-top: auto;'};
  border: none;
  background-color: transparent;
`;
